import React from 'react';
import { AntdSkeleton } from '@ui/components';

export const TrialsListSkeleton = () => {
  return (
    <div className="flex flex-col gap-2 px-4">
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
      <AntdSkeleton.Input className="w-full rounded-default h-[92px]" />
    </div>
  );
};
